<template>
  <div class="content-with-newsletter">
    <div class="content-block">
        <h4>{{ $t('newsletterTitle') }}</h4>
        <p v-html="$t('newsletterContent', { val: email })"></p>
    </div>
    <div class="content-form">
      <mailchimp-subscribe
        url="https://digital.us4.list-manage.com/subscribe/post-json"
        user-id="23fa6b0c9b58622121d2815e6"
        list-id="462b1a5895"
        @error="onError"
        @success="onSuccess"
    >
        <template v-slot="{ subscribe, setEmail, error, success, loading }">
          <div>
            <div class="form-sent" v-if="success">
              <font-awesome-icon icon="thumbs-up" />
              <p>{{ $t('newsletterSuccess') }}</p>
            </div>
            <div class="form-sent" v-else-if="loading">
              <font-awesome-icon icon="user-plus" />
              <p>{{ $t('newsletterLoading') }}</p>
            </div>
            <form @submit.prevent="subscribe" @change="checkForm" v-else>
                <VueInputUi v-model="email" type="email" v-bind:label="$t('newsletterLabel')" size="lg" :border-radius="4" color="#806543" @input="setEmail(email)" />
                <button type="submit">{{ $t('newsletterOk') }}</button>
            </form>
            <div class="form-sent" v-if="error">
              <font-awesome-icon icon="thumbs-down" />
              <p>{{ error }}</p></div>
          </div>
        </template>
      </mailchimp-subscribe>
      <p v-if="errors.length" class="form-error">
        <ul>
          <li v-for="error in errors">{{ error }}</li>
        </ul>
      </p>
    </div>
  </div>
</template>

<script>
  import MailchimpSubscribe from 'vue-mailchimp-subscribe'
  import VueInputUi from 'vue-input-ui';
  import 'vue-input-ui/dist/vue-input-ui.css';

  export default {
    name: 'ContentWithNewsletter',
    data() {    
      return {        
        email: '',
        errors: [],
      };
    },
    components: {
        MailchimpSubscribe,
        VueInputUi
    },
    methods: {
      checkForm: function (e) {
        this.errors = [];
        if (!this.email) {
          this.errors.push( $t('newsletterEmailBlank') );
        } else if (!this.validEmail(this.email)) {
          this.errors.push( $t('newsletterEmailValid') );
        }
        if (!this.errors.length) {
          return true;
        }

        e.preventDefault();
      },
      validEmail:function(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      },
      
      onError() {
        // console.log('error')
      },
      onSuccess() {
        // console.log('success')
      },
    },
  }
</script>

<style scoped lang="scss">
  .content-with-newsletter {
    @apply flex items-stretch pt-2;
    position: relative;
    z-index: 2;
    
    .content-block {
      @apply bg-cherry flex-1 text-white px-4 pb-4 pt-4;
      border-top-right-radius: 30% 2%;
      order: 2;
      h4 {
        @apply font-bold py-2 pl-2 text-xl;
        text-shadow: 1px 1px 1px #000;
      }
      p {
        @apply m-auto text-sm pl-2 pb-2;
        text-shadow: 1px 1px 1px #000;
      }
    }
    .content-form {
      @apply bg-pink flex flex-col flex-1 px-4 items-center justify-center;
      border-top-left-radius: 30% 3%;
      order: 1;
      position: relative;

      &:before {
        border-color: transparent;
        border-style: solid;
        border-width: 12px;
        border-right-color: #542f34;
        border-right-width: 8px;
        content: " ";
        display: block;
        height: 0;
        position: absolute;
        right: 0px;
        top: 1.75rem;
        width: 0;
      }

      form {
        @apply flex items-center max-w-sm m-auto;

        div.vue-input-ui {
          @apply flex-1;

          .vue-input-ui__input {
            @apply pr-6;
          }
        }

        button {
          @apply bg-gold -ml-6 px-6 py-2 text-white transition-bg uppercase;
          border-radius: 2% 30%;
          position: relative;
          z-index: 2;

          &:hover {
            @apply bg-cherry;
          }
        }
      }
    }

    .form-error {
      @apply pt-4 text-sm text-white;
    }

    .form-sent {
      @apply flex flex-col items-center text-sm text-white;

      svg {
        @apply block mb-2;
        font-size: 48px;
      }
    }

    @screen lg {
      .content-block {
        h4 {
          @apply text-base;
        }
        p {
          @apply text-xs;
        }
      }
    }

    @screen md {
      .content-block {
        h4 {
          @apply text-base;
        }
        p {
          @apply text-xs;
        }
      }
    }
    @screen sm {
      @apply bg-cherry flex-col text-center py-6;
      border-top-right-radius: 40% 2%;
      border-top-left-radius: 40% 2%;

      .content-block {
        @apply bg-transparent w-full;
        order: 1;

        h4 {
          @apply text-xl pl-0;
        }
        p {
          @apply text-sm pl-0 w-3/4;
        }
      }
      .content-form {
        @apply bg-transparent m-auto w-1/2 pl-0 pt-2 pb-4 pr-0;
        min-width: 260px;
        order: 2;

        form {
          button {
            &:hover {
              @apply bg-pink;
            }
          }
        }

        &:before {
          display: none;
        }
      }

      .form-sent {
        @apply flex text-xs;

        svg {
          font-size: 36px;
        }
      }
    }
  }
</style>